<template>
  <div class="sidebar bg-magnolia round-10 br-one mt-lg-50">
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-15">Search</h3>
      <form action="#" class="search-form">
        <input
          type="search"
          placeholder="Search"
          class="bg-white w-100 round-6 fs-15 mb-15"
        />
        <button type="submit" class="btn style-one border-0 d-block w-100">
          Search Now
        </button>
      </form>
    </div>
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-15">Categories</h3>
      <ul class="category-list list-style">
        <li>
          <router-link to="/shop-left-sidebar">
            Marketing
            <span>(09)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/shop-left-sidebar">
            Education
            <span>(03)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/shop-left-sidebar">
            Machine
            <span>(02)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/shop-left-sidebar">
            Business
            <span>(05)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/shop-left-sidebar">
            Digital Marketing
            <span>(07)</span>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <div class="sidebar-widget">
      <h3 class="fs-20 mb-15">Filter By Price</h3>
      <div class="center">
        <div class="multi-range">
          <input
            id="min"
            type="range"
            min="0"
            max="100"
            value="0"
            step="0.0001"
          />
          <input
            id="max"
            type="range"
            min="0"
            max="100"
            value="100"
            step="0.0001"
          />
        </div>
        <div class="price-title">
          <p class="me-2 mb-0">Price</p>
          <div class="price">
            <span id="from">$56</span><span> - </span><span id="to">$907</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-20">New Products</h3>
      <div class="pp-post-item-wrap style-two">
        <div class="pp-post-item d-flex align-items-center">
          <div class="pp-post-img rounded-1 br-one py-4">
            <img
              src="../../assets/img/shop/product-thumb-1.webp"
              alt="Image"
              class="d-block mx-auto"
            />
          </div>
          <div class="pp-post-info">
            <span>$90.00</span>
            <h5 class="fs-18 mb-0 mt-1">
              <router-link to="/product-details"> Can Fish </router-link>
            </h5>
          </div>
        </div>
        <div class="pp-post-item d-flex align-items-center">
          <div class="pp-post-img rounded-1 br-one py-4">
            <img
              src="../../assets/img/shop/product-thumb-2.webp"
              alt="Image"
              class="d-block mx-auto"
            />
          </div>
          <div class="pp-post-info">
            <span>$56.00</span>
            <h5 class="fs-18 mb-0 mt-1">
              <router-link to="/product-details"> Cat Food </router-link>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-widget">
      <h3 class="fs-20">Taglist</h3>
      <ul class="tag-list list-style">
        <li>
          <router-link to="/shop-right-sidebar">Business</router-link>
        </li>
        <li>
          <router-link to="/shop-right-sidebar">Education</router-link>
        </li>
        <li>
          <router-link to="/shop-right-sidebar">Marketing</router-link>
        </li>
        <li>
          <router-link to="/shop-right-sidebar">SEO</router-link>
        </li>
        <li>
          <router-link to="/shop-right-sidebar">Online</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarWidget",
};
</script>